import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { DataGridPerson } from '@components/DataGrid/DataGridPerson'
import { useLocation, useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Menu,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from '@mantine/core'
import classes from '@styles/record.module.css'
import {
  IconChevronDown,
  IconDots,
  IconPhoneIncoming,
  IconPhoneOutgoing,
} from '@tabler/icons-react'
import { randomArrayItem } from '@utils/randomArrayItem'
import { randomBool } from '@utils/randomBool'
import { DataGridList } from '@components/DataGrid/DataGridList'
import { StageListItem } from '@components/StageList/StageList'
import cn from 'classnames'
import ExampleUser from '@assets/exampleUser.png'

export interface CallProps {
  fullWidth?: boolean
  state?: { history: any }
}

export const Calls = (props: CallProps) => {
  const { fullWidth, state } = props

  const navigate = useNavigate()
  const location = useLocation()

  const handleNavigate = () =>
    navigate(
      `../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`,
      location?.state?.history
        ? { state: location?.state }
        : state
        ? { state }
        : {},
    )

  const data = Array(30)
    .fill(0)
    .map((_, i) => {
      const callDirection = randomBool()
        ? { label: 'Outgoing', component: <IconPhoneOutgoing size={22} /> }
        : { label: 'Incoming', component: <IconPhoneIncoming size={22} /> }

      return {
        id: `invite-${i}`,
        timeAndDate: (
          <Flex>
            <Tooltip label={callDirection.label}>
              <ThemeIcon variant="transparent" c="gray.5" mr={3}>
                {callDirection.component}
              </ThemeIcon>
            </Tooltip>
            <Stack gap={0}>
              <Text size="xs">5:59pm</Text>
              <Text size="xs" c="dimmed">
                Mar 11
              </Text>
            </Stack>
          </Flex>
        ),
        staff: (
          <DataGridPerson
            name="Alfredo Carrillo"
            status="online"
            onClick={handleNavigate}
          />
        ),
        record: (
          <DataGridPerson
            name="Joey Cadle"
            image={ExampleUser}
            status="online"
            onClick={handleNavigate}
          />
        ),
        purpose: randomArrayItem(['Intro', 'Request info', 'Inform']),
        notes: randomArrayItem([
          'Let him know how...',
          'Don’t forget to bring presents.',
          'Remind him to take care of him...',
          'Don’t forget that thing that was ...',
        ]),
        disposition: randomArrayItem(['Answered', 'No answer', 'Voicemail']),
        tags: (
          <DataGridList title="Tags" data={['Some', 'Another', 'Another']} />
        ),
      }
    })

  const fullWidthCols = fullWidth
    ? [
        {
          label: 'Time & Date',
          prop: 'timeAndDate',
          defaultSort: true,
          pinned: true,
        },
        {
          label: 'Record',
          prop: 'record',
        },
      ]
    : [
        {
          label: 'Time & Date',
          prop: 'timeAndDate',
          defaultSort: true,
          pinned: true,
        },
      ]
  const columns: DataGridColumns[] = [
    ...fullWidthCols,
    {
      label: 'Staff',
      prop: 'staff',
    },
    {
      label: 'Purpose',
      prop: 'purpose',
    },
    {
      label: 'Notes',
      prop: 'notes',
    },
    {
      label: 'Disposition',
      prop: 'disposition',
    },
    {
      label: 'Tags',
      prop: 'tags',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'All Calls',
      href: '#',
      default: true,
    },
    {
      label: 'My Calls',
      href: '#',
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Edit',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Add tags',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Remove tags',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Delete',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Tags',
      onClick: (items: any) => console.log('Selected Actions: Tags'),
      component: (
        <div>
          <Menu position="bottom-start">
            <Menu.Target>
              <Button
                variant="default"
                rightSection={<IconChevronDown size={18} />}
              >
                Tags
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Add tags</Menu.Item>
              <Menu.Item color="red">Remove tags</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
    {
      label: 'Options',
      onClick: (items: any) => {},
      component: (
        <div>
          <Menu>
            <Menu.Target>
              <ActionIcon variant="default" radius="xl" aria-label="Options">
                <IconDots
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item color="red">Delete</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
  ]

  const stages: StageListItem[] = [
    {
      name: 'Total',
      count: 4,
    },
    {
      name: 'Answered',
      count: 1,
    },
    {
      name: 'Not Answered',
      count: 3,
    },
  ]

  return (
    <Box className={cn({ [classes.Record__content]: !fullWidth })}>
      <DataGrid
        data={data}
        columns={columns}
        sections={sections}
        actions={actions}
        results={data.length}
        stages={stages}
        buttons={<Button>Log Call</Button>}
        selectedActions={selectedActions}
        page={1}
      />
    </Box>
  )
}
